(function() {
	'use strict';
	angular.module('pharmaPortalApp').factory('PharmaReceptionInvoice', PharmaReceptionInvoice);

	PharmaReceptionInvoice.$inject = [ '$resource' ];

	function PharmaReceptionInvoice($resource) {
		var resourceUrl = 'api/pharma-reception-invoice/:id';

		return $resource(resourceUrl, {}, {
			'get' : {
				method : 'GET',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
			'save' : {
				method : 'POST',
				transformRequest : function(data) {
					try {
						angular.forEach(data, function(meta) {
						});
					} catch (err) {
					}
					return angular.toJson(data);
				}
			}
		});
	}
})();
